/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgActionAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M4 12c0-4.4 3.6-8 8-8s8 3.6 8 8h2c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10v-2c-4.4 0-8-3.6-8-8z" />
      <path d="M12 8c2.2 0 4 1.8 4 4h2c0-3.3-2.7-6-6-6s-6 2.7-6 6 2.7 6 6 6v-2c-2.2 0-4-1.8-4-4s1.8-4 4-4z" />
      <path d="m22.7 21.3-3.1-3.1 2-1.3c.3-.2.5-.6.4-1s-.3-.7-.7-.8l-7-2c-.3-.1-.7 0-1 .3s-.4.6-.3 1l2 7c.1.4.4.7.8.7.4.1.8-.1 1-.4l1.3-2 3.1 3.1zm-6.3-2.7-.9-3.2 3.2.9-1.2.8-.3.3z" />
    </g>
  </Icon>
);
export { SvgActionAlt as ActionAlt };
